module.exports = __webpack_public_path__ + "static/media/9.f5e2c5ce.jpg";